/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import End from './End/index'
import LoadMore from './LoadMore/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/LoadMoreAction/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let loadMoreStatusValueData = fromData.useDataValue({ viewPath,
context: 'load_more',
path: 'status',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: loadMoreStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LoadMore'}>
<LoadMore
  viewPath={`${viewPath}/LoadMore`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'End'}>
<End
  viewPath={`${viewPath}/End`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}